<template>
    <div class="wrap">
        <div class="title reveal-bottom">{{ title }}</div>
        <div class="subTitle reveal-bottom">{{ subTitle }}</div>
    </div>
</template>
<script>
export default {
    name: "DetailHeader",
    props: {
        title: String,
        subTitle: String,
    },
};
</script>
<style scoped>
.wrap {
    width: 960px;
    margin: 176px auto 0;
}
.title {
    font-size: 44px;
    color: #000;
    letter-spacing: 0;
    line-height: 60px;
    font-weight: bold;
}
.subTitle {
    margin-top: 24px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    letter-spacing: 0;
    line-height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/NewDetail/Header.vue